module.exports = __webpack_public_path__ + "img/8b74979.jpg";